import React from "react";
import { Navbar } from "../../components/user-components/NavigationBar/Navbar";
import { HeroSection } from "../../components/user-components/HeroSection/HeroSection";

export const Landing = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
    </>
  );
};
